import { getUniversalCategory } from '@/features/shop/services/UniversalCategories/utils'
import { getSelectedParams } from '@/features/shop/services/Search/utils'
import { useParams } from 'next/navigation'

export const useCurrentUniversalCategory = () => {
  const params = useParams<{ slug?: string | string[] }>()
  const slug = getSelectedParams(params?.slug ?? '')
  return getUniversalCategory([...slug])
}
